<script>

/**
 * Automodal 
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'

import { archetype, automodalHandler, archetypeNutriusuarios } from './usuarioArchetype'
import {extractForm} from '@/utils.js'
import usuariosClientedatos from './usuarios-clientedatos.vue'
import UsuariosClientefacturacion from './usuarios-clientefacturacion.vue'
import usuarioexpedienteQuicktable from '../../Usuarioexpediente/UsuarioexpedienteQuicktable.vue'
import UsuariosclientebinariosQuicktable from '../../Usuariosclientebinarios/UsuariosclientebinariosQuicktable.vue'

import MonederoQuicktable from '@/views/Monedero/quicktable.vue'
import MonederoUserOverview from '../../Monedero/monedero-user-overview.vue'
import UserOverview from '../../Easylunch/UserOverview.vue'
import PedidosIndex from '../../Pedidos/PedidosIndex.vue'
import menusIndex from '../../Nutricion/MenusMainCard.vue'
import MenuClonadoParaUsuario from '../../Nutricion/MenuClonadoParaUsuario.vue'

export default {
    components: { 
        usuarioexpedienteQuicktable,
        UsuariosclientebinariosQuicktable,
        usuariosClientedatos, 
        UsuariosClientefacturacion, 
        MonederoQuicktable, 
        MonederoUserOverview, 
        UserOverview, 
        PedidosIndex, 
        menusIndex, 
        MenuClonadoParaUsuario
    },
    name: 'usuarioModal',
    props: {
        pageSize: {
            type: [Number, String],
            default: 10
        },
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        },
        btnClass: {
            type: String,
            default: "btn btn-primary",
        },
    },
    data: () => {
        return {
            isShown: false,
            form: extractForm(archetype),
            formExtended: {
                nutriusuariosCfg: null,
                nutricion_comentarios: null,
                clientedatos: null,
                clientefacturacion: null,
            },

            asides: {
                estados: [],
                bancos: [],
                nutriequivalencias: [],
                clientedatos: null,
                clientefacturacion: null,
            }
        }
    },
    computed: {
        formArchetypeMD5() {
            return md5(JSON.stringify(this.cArchetype))
        },
        cArchetype() {
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if (!_.isArray(itemsRow)) {
                    updated.push(itemsRow);
                    return
                }
                let adding = []
                _.forEach(itemsRow, item => {
                    // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO

                    // if(item.key == 'key-name'){
                    // DO SOMENTHING
                    // }

                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        beforeStore(form){
            let newForm = _.merge(form, this.formExtended);
            return newForm;
        },
        tryToRefreshMenus(){
            if(typeof this.$refs.menusIndex != 'undefined' && _.isFunction(this.$refs.menusIndex.refresh))
                this.$refs.menusIndex.refresh();
            console.log('tryToRefreshMenus');
        },
        archetypeNutriusuarios() {
            let a = _.map(archetypeNutriusuarios(), (item, indexItem) => {
                if (item.key == 'equivalencias_id') 
                    item.options = _.clone(this.asides.nutriequivalencias)
                return item;
            });
            return a;
        },
        monederoUpdated() {
            if (_.isObjectLike(this.$refs.monederUserOverview)) {
                this.$refs.monederUserOverview.loadUp()
            }
        },
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (asides) {
                this.asides.clientedatos = asides.clientedatos
                this.formExtended.clientedatos = _.cloneDeep(asides.clientedatos)
                this.asides.clientefacturacion = asides.clientefacturacion
                this.formExtended.clientefacturacion = _.cloneDeep(asides.clientefacturacion)
                this.formExtended.nutriusuariosCfg = _.cloneDeep(this.form.nutriusuariosCfg)
                this.formExtended.nutricion_comentarios = _.cloneDeep(this.form.nutricion_comentarios)

                this.asides.estados = asides.estados
                this.asides.bancos = asides.bancos
                this.asides.nutriequivalencias = _.cloneDeep(asides.nutriequivalencias)
            }
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
            this.isShown = true;
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
            this.isShown = false;
            this.refresh()
        },

    },
    watch: {
        'asides.clientedatos'() {
            this.form.clientedatos = _.clone(this.asides.clientedatos)
            this.$refs.automodal.updateFromModel()
        },
        'asides.clientefacturacion'() {
            this.form.clientefacturacion = _.clone(this.asides.clientefacturacion)
            this.$refs.automodal.updateFromModel()
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" size="xxl" class="usuario-modal" 
        :form-id="form.id_pk"
        :form-archetype="cArchetype" 
        :handler="getHandler()" 
        :allow-aside="true" 
        :allow-delete="true"
        :form-key="formArchetypeMD5" 
        :btn-class="btnClass" 
        :beforeStore="beforeStore"
        @refresh="refresh()" 
        @defined="checkAsides()"
        @display="onDisplay" 
        @hidden="onHidden">

        <menu-clonado-para-usuario ref="menuClonado" @refresh="tryToRefreshMenus"/>

        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="9">

            <!-- LATERAL, REQUIERE :allow-aside="true" -->
            <b-card class="usuarioModalAside" v-if="isShown && form.id_pk" no-body>

                <monedero-user-overview :userId="form.id_pk" ref="monederUserOverview" />

                <b-tabs pills card>

                    <b-tab title="Easy Lunch" no-body active>
                        <user-overview :usuariosId="form.id_pk" />
                    </b-tab>

                    <b-tab title="Pedidos">
                        <pedidos-index :args="{usuarioIdPk: this.form.id_pk}" :page-size="pageSize" hide-new />
                    </b-tab>
                    
                    <b-tab title="Planes">
                        <menus-index ref="menusIndex" :args="{usuarioIdPk: this.form.id_pk}" :page-size="pageSize">
                            <b-button slot="mainButtons" @click="$refs.menuClonado.clonarMenu(form.id_pk)" variant="info"> 
                                Clonar menú 
                            </b-button>
                        </menus-index>
                        
                    </b-tab>

                    <b-tab title="Relación nutricional">
                        <grid-input class="relac-nutri" v-model="formExtended.nutriusuariosCfg" :archetype="archetypeNutriusuarios" />
                        <b-form-group label="Comentarios de nutrición" class="mt-3">
                            <b-form-textarea id="comentarios-nutricion" v-model="formExtended.nutricion_comentarios" placeholder="Escribe tus comentarios aquí"></b-form-textarea>
                        </b-form-group>
                    </b-tab>

                    <b-tab title="Expedientes">
                        <usuarioexpediente-quicktable :usuario-id="form.id_pk" />
                    </b-tab>
                    
                    <b-tab title="Archivos">
                        <UsuariosclientebinariosQuicktable :args="{usuarioId: form.id_pk}" />
                    </b-tab>

                    <b-tab title="Depósitos" no-body>
                        <monedero-quicktable class="fix-style" :usuarioId="form.id_pk" @updated="monederoUpdated" />
                    </b-tab>

                    <b-tab title="Otros datos" class="fix-padding">
                        <b-tabs pills vertical card no-body no-gutters>
                            <b-tab title="Datos de cliente">
                                <usuarios-clientedatos v-model="formExtended.clientedatos" :source="asides.clientedatos" :estados="asides.estados" />
                            </b-tab>
                            <b-tab title="Datos de facturación">
                                <usuarios-clientefacturacion v-model="formExtended.clientefacturacion" :source="asides.clientefacturacion" :estados="asides.estados" :bancos="asides.bancos" />
                            </b-tab>
                        </b-tabs>
                        <!-- <h3>Datos de cliente</h3> -->
                        <!-- <usuarios-clientedatos v-model="formExtended.clientedatos" :source="asides.clientedatos" :estados="asides.estados" /> -->
                        <!-- <hr> -->
                        <!-- <h3>Datos de facturación</h3> -->
                        <!-- <usuarios-clientefacturacion v-model="formExtended.clientefacturacion" :source="asides.clientefacturacion" :estados="asides.estados" :bancos="asides.bancos" /> -->
                    </b-tab>

                </b-tabs>
            </b-card>

            <!-- Jumbotron para placeholder de carga de datos -->
            <b-jumbotron v-else>
                <h1 class="display-4">Cargando...</h1>
                <p class="lead">Por favor, espera un momento.</p>
            </b-jumbotron>
        </b-col>
        <b-col slot="bottom" v-if="false">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
        
    </ui-edit-auto-modal>
</template>

<style lang="less">
.usuarioModalAside {

    .relac-nutri {
        .ui-input-handler {
            // &.comentarios {
            //     flex: 1 0 auto !important;
            // }
            &.dia {
                max-width: 6em;
            }
            &.equivalencias_id {
                // flex: 0 1 10em;
            }
            &.cantidad {
                flex: 0 1 8em;
            }
        }
    }

    .fix-style {
    
        .card-header,
        .card-footer {
            background-color: inherit;
            border-bottom: 0px;
        }
    
        .card {
            border: none;
            margin-bottom: 0;
        }
    
    }

    .fix-padding {
        padding: 0;
    }
}
</style>